<template>
  <div id="profileContainer">
    <div id="contentsContainer">
      <div class="itemContainer">
        <div class="itemTitle">회원 정보</div>
        <div class="itemDetailContainer">
          <div style="font-size:18px;line-height:18px;letter-spacing: -0.6px;color:#A5A5A5;margin-right: 28px">이메일</div>
          <div style="font-size:18px;line-height:18px;letter-spacing: -0.6px;color:#333333;">{{email}}</div>
          <div id="changePasswordButton" @click="onChangePassword">비밀번호 변경</div>
        </div>
      </div>

      <div class="itemContainer">
        <div class="itemTitle">서비스 이용 정보</div>
<!--        컴포넌트로 만들면 좋을듯 -->
        <div v-if="subscriptions === null || subscriptions.length === 0">서비스 이용 정보가 없습니다.</div>
        <div v-else>
          <div
            v-for="(subscription, index) in subscriptions"
            :key=index
            class="itemDetailContainer"
          >
            <div class="serviceName">{{getCategoryName(subscription.value.productCategory)}}</div>
            <div class="serviceState">{{isSubscriptingDesc(subscription.value)}}</div>
            <div class="servicePeriod">{{getSubscriptionDesc(subscription.value)}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import {api} from "../../../mixins/api";

export default {
  name: "ProfileComponent",
  async beforeCreate() {
    let profile = await api.methods.getProfileApi();
    this.email = profile.email;
    this.subscriptions = await api.methods.getSubscriptionsApi();
  },
  data() {
    return {
      email: null,
      subscriptions: null
    }
  },
  methods: {
    onChangePassword() {
      this.$router.push('changePassword');
    },
    getCategoryName(v) {
      switch (v) {
        case 1:
          return '리치고 부동산';
        case 2:
          return '리치고 경제';
        case 100:
          return '아파트 전망 리포트';
        case 101:
          return '경제 전망 리포트';
        default:
          return v;
      }
    },
    isSubscripting(v) {
      const now = Date.now();
      const startTime = new Date(v.startTime);
      const endTime = new Date(v.endTime);
      return startTime.getTime() <= now && now < endTime.getTime();
    },
    isSubscriptingDesc(v) {
      return this.isSubscripting(v) === true ? '서비스 이용 중' : ' 서비스 종료';
    },
    getSubscriptionDesc(v) {
      const startTime = new Date(v.startTime);
      const endTime = new Date(v.endTime);
      return `${startTime.format('yyyy-MM-dd (KS) HH:mm:ss')} ~ ${endTime.format('yyyy-MM-dd (KS) HH:mm:ss')}`;
    }
  }
}
</script>

<style scoped>
#profileContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'HDharmony', sans-serif;
}
#contentsContainer {
  /*#폰트 넣*/
  background: #FFFFFF;
  border-radius: 30px;
  width: 760px;
  height: 580px;
  padding: 64px 80px;
}

.itemContainer {
  width: 600px;
  margin-bottom: 54px;
}

.itemTitle {
  font-size: 24px;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: #333333;
  margin-bottom: 40px;
}

.itemDetailContainer {
  display: flex;
  align-items: center;
  padding: 18px 20px;
  border-bottom: 1.5px solid #D2D2D2;
}

#changePasswordButton {
  margin-left:auto;
  color: #FFFFFF;
  background: #333333;
  border-radius: 4px;
  padding: 8px;
}

#changePasswordButton:hover {
  cursor: pointer;
}

.serviceName {
  color: #333333;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.6px;
  margin-right: 8px;
}

.serviceState {
  color: #FFFFFF;
  background: #3B82F6;
  border-radius: 100px;
  font-size: 10px;
  line-height: 10px;
  padding: 4px 6px;

}
.servicePeriod {
  margin-left: auto;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.6px;
  color: #A5A5A5;
}

</style>
